import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Navbar from './Navbar'
import Footer from './Footer'
import SEO from './SEO'

export default function Privacy() {
  const { t } = useTranslation()

  const rightsRaw = t('datenschutz.s3rights', { returnObjects: true })
  const cookieTypesRaw = t('datenschutz.s4cookies', { returnObjects: true })
  const logItemsRaw = t('datenschutz.s4logs', { returnObjects: true })
  const rights = Array.isArray(rightsRaw) ? rightsRaw : []
  const cookieTypes = Array.isArray(cookieTypesRaw) ? cookieTypesRaw : []
  const logItems = Array.isArray(logItemsRaw) ? logItemsRaw : []

  return (
    <>
      <SEO titleKey="seo.privacy.title" descriptionKey="seo.privacy.description" path="/privacy" />
      <Navbar />
      <section className="bg-sand min-h-screen py-24 px-6">
        <div className="max-w-3xl mx-auto font-body text-espresso">
          <Link to="/" className="text-rot text-sm hover:underline mb-8 inline-block">
            {t('datenschutz.back')}
          </Link>

          <h1 className="font-headline text-4xl md:text-5xl mb-10">{t('datenschutz.title')}</h1>
          <p className="text-sm text-espresso/60 mb-8">{t('datenschutz.date')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s1h2')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s1h3a')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s1p1')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s1h3b')}</h3>
          <p className="mb-2">
            <strong>{t('datenschutz.s1q1')}</strong>
          </p>
          <p className="mb-4 leading-relaxed">
            {t('datenschutz.s1a1intro')}
            <br />
            <strong>Buenas Studio</strong>
            <br />
            Christina Mathis - Marketing &amp; IT Services
            <br />
            E-Mail: hi@buenas-studio.com
          </p>

          <p className="mb-2">
            <strong>{t('datenschutz.s1q2')}</strong>
          </p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s1a2')}</p>

          <p className="mb-2">
            <strong>{t('datenschutz.s1q3')}</strong>
          </p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s1a3')}</p>

          <p className="mb-2">
            <strong>{t('datenschutz.s1q4')}</strong>
          </p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s1a4')}</p>
          <p className="mb-4">
            {t('datenschutz.s1a4b')} <strong>hi@buenas-studio.com</strong>
          </p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s2h2')}</h2>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s2p1')}</p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s2p2')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s3h2')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s3h3a')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s3p1')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s3h3b')}</h3>
          <p className="mb-4 leading-relaxed">
            <strong>Buenas Studio</strong>
            <br />
            Christina Mathis - Marketing &amp; IT Services
            <br />
            E-Mail: hi@buenas-studio.com
          </p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s3p2')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s3h3c')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s3p4')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s3h3d')}</h3>
          <ul className="list-disc pl-6 mb-4 space-y-1 leading-relaxed">
            {rights.map((item, i) => (
              <li key={i} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
          <p className="mb-4">
            {t('datenschutz.s3contact')} <strong>hi@buenas-studio.com</strong>
          </p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s4h2')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s4h3a')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s4p1')}</p>
          <p className="mb-2">{t('datenschutz.s4types')}</p>
          <ul className="list-disc pl-6 mb-4 space-y-1 leading-relaxed">
            {cookieTypes.map((item, i) => (
              <li key={i} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s4p2')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s4h3b')}</h3>
          <p className="mb-2 leading-relaxed">{t('datenschutz.s4logp')}</p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            {logItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s4logp2')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s4h3c')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s4contactp1')}</p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s4contactp2')}</p>
          <p className="mb-1">
            <strong>{t('datenschutz.s4storedLabel')}</strong> {t('datenschutz.s4storedValue')}
          </p>
          <p className="mb-4">
            <strong>{t('datenschutz.s4retentionLabel')}</strong> {t('datenschutz.s4retentionValue')}
          </p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s5h2')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s5h3')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s5p1')}</p>
          <p className="mb-4 leading-relaxed">
            <strong>{t('datenschutz.s5ipLabel')}</strong> {t('datenschutz.s5ipText')}
          </p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s5consent')}</p>
          <p className="mb-4 leading-relaxed">
            <strong>{t('datenschutz.s5contractLabel')}</strong> {t('datenschutz.s5contractText')}
          </p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s6h2')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s6h3')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s6p1')}</p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s6p2')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s7h2')}</h2>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s7p1')}</p>
          <p className="mb-1">
            <strong>{t('datenschutz.s7storedLabel')}</strong> {t('datenschutz.s7storedValue')}
          </p>
          <p className="mb-1">
            <strong>{t('datenschutz.s7purposeLabel')}</strong> {t('datenschutz.s7purposeValue')}
          </p>
          <p className="mb-4">
            <strong>{t('datenschutz.s7legalLabel')}</strong> {t('datenschutz.s7legalValue')}
          </p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s7unsubscribe')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s8h2')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('datenschutz.s8h3')}</h3>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s8p1')}</p>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s8p2')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s9h2')}</h2>
          <p className="mb-4 leading-relaxed">{t('datenschutz.s9p')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('datenschutz.s10h2')}</h2>
          <p className="mb-4 leading-relaxed">
            <strong>Buenas Studio</strong>
            <br />
            Christina Mathis - Marketing &amp; IT Services
            <br />
            E-Mail: hi@buenas-studio.com
          </p>

          <p className="text-sm text-espresso/50 mt-12 leading-relaxed">
            <em>{t('datenschutz.footernote')}</em>
          </p>
        </div>
      </section>
      <Footer />
    </>
  )
}
